module.exports = __webpack_public_path__ + "static/media/matheus.87019a93.jpeg";